/**
 * Constantes relacionadas ao Artemis Ads SDK
 */

export const ARTEMIS_ZONES = {
  /** Zona de Apps (Zone 2) */
  APPS: 'c0e16d43-4039-446e-a708-0bec66259111',
  CAPTIVE_PORTAL: '560f28a0-77b4-41a5-aa1d-ec4ae9269ee2',
  /** Zona de 1st View (vídeo automático ao abrir a home) */
  FIRST_VIEW: '8ee29292-ca5f-450f-adfd-a6675cc756b3',
} as const;

export const ARTEMIS_CONFIG = {
  /** Limite padrão de campanhas por requisição */
  DEFAULT_LIMIT: 10,
  /** Número máximo de tentativas em caso de erro */
  MAX_RETRIES: 3,
  /** Timeout para requisições (em ms) */
  REQUEST_TIMEOUT: 30000,
} as const;
